import * as THREE from 'three';
import * as PANOLENS from 'panolens';
import white from '../../includedAssets/white.png';

export default class InfoMenuDivider {
  constructor(panorama, menuConfig) {
    this.panorama = panorama;
    this.menuConfig = menuConfig;
    this.lineMesh = this.createLine();
  }


  createLine() {
    const info = new PANOLENS.Infospot(1, white, false, {
      staticScale: new THREE.Vector3(2400, 4, 1),
    });
    info.position.fromArray(this.menuConfig.position);
    info.setCursorHoverStyle('default');
    info.name = `divider`;
    this.panorama.add(info);
    return info;
  }


  show() {
    if (this.lineMesh) this.lineMesh.visible = true;
  }


  hide() {
    if (this.lineMesh) this.lineMesh.visible = false;
  }
}